import {
  REJECT_PENDING_REQUEST_REQUEST,
  REJECT_PENDING_REQUEST_SUCCESS,
  REJECT_PENDING_REQUEST_FAILURE,
} from '../../../../Constants/actionTypes';

import { rejectPendingRequestApi } from '../../../../Constants/apiService';

export const rejectPendingRequestRequest = () => ({ type: REJECT_PENDING_REQUEST_REQUEST });
export const rejectPendingRequestSuccess = (data) => ({ type: REJECT_PENDING_REQUEST_SUCCESS, payload: data });
export const rejectPendingRequestFailure = (error) => ({ type: REJECT_PENDING_REQUEST_FAILURE, payload: error });

export const rejectPendingRequestAct = (requestId) => {
  return async (dispatch, getState) => {
    dispatch(rejectPendingRequestRequest());

    const accessToken = getState()?.auth?.accessToken;

    try {
      const data = await rejectPendingRequestApi(requestId, accessToken);
      dispatch(rejectPendingRequestSuccess(data));
      return data;
    } catch (error) {
      const errorMessage =
        error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
          ? 'Server is currently down. Please try again later.'
          : error?.message || 'Something went wrong';

      dispatch(rejectPendingRequestFailure(errorMessage));
      return null;
    }
  };
};
